import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../../layout/Footer';
import { Container, Row, Col, Card, Table } from 'react-bootstrap';
import { getFromAPI, postToAPI } from '../../../../Utils/utils';
import { toast } from 'react-toastify';
import $ from 'jquery';
import DataTable from 'datatables.net-dt';
import JSZip from 'jszip';
import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

export default function OpeningBalance({ tableName = "Opening Leave Balance" }) {
  const [productData, setProductData] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [casualLeaveData, setCasualLeaveData] = useState(null);
  const [openingLeave, setOpeningLeaveData] = useState([]);
  const [leaveData, setLeaveData] = useState([]); // (kept if you need elsewhere)
  const isStaffId = Number(localStorage.getItem('loggedInStaffId'));
  const tableRef = useRef(null); // Reference to the DataTable instance

  /** Fetch opening balance data **/
  const fetchOpeningBalanceData = async () => {
    try {
      const response = await getFromAPI('FtsOpeningBalance/');
      setOpeningLeaveData(response);
    } catch (error) {
      console.error('Error fetching opening balance:', error);
      return null;
    }
  };

  /** Fetch staff and casual leave data **/
  const fetchAllData = async () => {
    try {
      const [staffResponse, casualLeaveResponse] = await Promise.all([
        getFromAPI('FtsStaff/'),
        getFromAPI('FtsOptions/?name=casual_leave')
      ]);

      setStaffData(staffResponse);
      setCasualLeaveData(casualLeaveResponse[0]?.value || 0);
    } catch (error) {
      console.error('Error fetching staff or casual leave data:', error);
      return null;
    }
  };

  const calculateFinancialYearLeave = (leaveData) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth(); // 0-based
    let financialYearStart, financialYearEnd;

    if (currentMonth >= 3) {
      financialYearStart = new Date(`${currentYear}-04-01`);
      financialYearEnd = new Date(`${currentYear + 1}-03-31`);
    } else {
      financialYearStart = new Date(`${currentYear - 1}-04-01`);
      financialYearEnd = new Date(`${currentYear}-03-31`);
    }

    let totalLeaveConsumed = 0;

    leaveData.forEach((leave) => {
      const startDate = new Date(leave.leave_start_date);
      const endDate = new Date(leave.leave_end_date);

      if (isNaN(startDate) || isNaN(endDate)) {
        return;
      }

      let leaveDays = parseFloat(leave.leave_total_days);
      if (isNaN(leaveDays) || leaveDays < 0) {
        return;
      }

      if (startDate >= financialYearStart && startDate <= financialYearEnd) {
        totalLeaveConsumed += leaveDays;
      }
    });

    if (isNaN(totalLeaveConsumed)) {
      totalLeaveConsumed = 0;
    }

    totalLeaveConsumed = Math.round(totalLeaveConsumed * 2) / 2;
    return totalLeaveConsumed;
  };

  const fetchLeaveData1 = async (email, id) => {
    try {
      const response = await getFromAPI(`FtsLeave/?leaver_email=${email}&leave_type=Casual Leave&leave_status=Approved&created_user_id=${id}`);

      if (Array.isArray(response) && response.length > 0) {
        const sortedData = response.slice().sort((a, b) => new Date(b.leave_start_date) - new Date(a.leave_start_date));
        const totalLeaveConsumed = calculateFinancialYearLeave(response);

        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth();

        let lastFinancialYearStart, lastFinancialYearEnd;
        if (currentMonth >= 3) {
          lastFinancialYearStart = new Date(`${currentYear - 1}-04-01`);
          lastFinancialYearEnd = new Date(`${currentYear}-03-31`);
        } else {
          lastFinancialYearStart = new Date(`${currentYear - 2}-04-01`);
          lastFinancialYearEnd = new Date(`${currentYear - 1}-03-31`);
        }

        let lastYearLeaveData = sortedData.find(entry => {
          const leaveEndDate = new Date(entry.leave_end_date);
          return leaveEndDate >= lastFinancialYearStart && leaveEndDate <= lastFinancialYearEnd;
        });
        const leaveadd = Number(lastYearLeaveData ? lastYearLeaveData.leave_balance : 0);
        const remainingleave = totalLeaveConsumed;
        return { leaveadd, remainingleave };
      } else {
        return { leaveadd: 0, remainingleave: 0 };
      }
    } catch (error) {
      console.error('Error fetching leave data:', error);
      return null;
    }
  };

  const isDateInFinancialYear = (date) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    let financialYearStart, financialYearEnd;
    if (currentMonth >= 3) {
      financialYearStart = new Date(`${currentYear}-04-01`);
      financialYearEnd = new Date(`${currentYear + 1}-03-31`);
    } else {
      financialYearStart = new Date(`${currentYear - 1}-04-01`);
      financialYearEnd = new Date(`${currentYear}-03-31`);
    }

    return date >= financialYearStart && date <= financialYearEnd;
  };

  // NEW: Proration helper — 1–14 -> full CL, 15–end -> half CL (only if joining is in current FY)
  const getProratedCasualLeave = (joiningDate, baseCL) => {
    const base = Number(baseCL) || 0;
    if (isNaN(joiningDate)) return base;

    // If they joined outside the current FY, just return the base CL
    if (!isDateInFinancialYear(joiningDate)) return base;

    const day = joiningDate.getDate();
    return day >= 1 && day <= 14 ? base : base / 2;
  };

  /** Update Product Data When Staff & Casual Leave Data Changes **/
  useEffect(() => {
    const updateLeaveData = async () => {
      if (staffData.length > 0 && casualLeaveData !== null) {
        const updatedProductData = await Promise.all(staffData.map(async (staff) => {
          const openingBalanceEntry = openingLeave.find(balance => balance.staffId === staff.staffid);
          const openingBalance = openingBalanceEntry ? Number(openingBalanceEntry.opening_leave) || 0 : 0;
          const { leaveadd, remainingleave } = await fetchLeaveData1(staff.email, staff.staffid);

          const joiningDate = new Date(staff.joining_date);
          const adjustedCasualLeave = getProratedCasualLeave(joiningDate, casualLeaveData);

          let totalLeave;
          if (openingBalanceEntry && openingBalanceEntry.total_leave !== null && openingBalanceEntry.total_leave !== undefined) {
            totalLeave = Number(openingBalanceEntry.total_leave);
          } else if (openingBalanceEntry) {
            totalLeave = openingBalance + adjustedCasualLeave;
          } else {
            totalLeave = openingBalance + adjustedCasualLeave;
          }

          const remainingLeaveBalance = totalLeave - remainingleave;

          return {
            staffId: staff.staffid,
            staffName: staff.firstname,
            openingBalance: openingBalance,
            casualLeave: totalLeave - openingBalance, // equals adjustedCasualLeave
            balanceLeave: remainingLeaveBalance
          };
        }));

        setProductData(updatedProductData);
      }
    };

    updateLeaveData();
  }, [staffData, casualLeaveData, openingLeave]);

  /** Fetch Data on Component Mount **/
  useEffect(() => {
    fetchOpeningBalanceData();
    fetchAllData();
  }, []);

  /** Handle opening balance change **/
  const handleOpeningBalanceChange = (index, value) => {
    const updatedData = [...productData];
    const openingBalance = Number(value) || 0;

    const staff = staffData.find(s => s.staffid === updatedData[index].staffId);
    const joiningDate = new Date(staff.joining_date);

    const adjustedCasualLeave = getProratedCasualLeave(joiningDate, casualLeaveData);

    const totalLeave = openingBalance + adjustedCasualLeave;
    let balanceLeave = totalLeave;

    updatedData[index] = {
      ...updatedData[index],
      openingBalance: openingBalance,
      casualLeave: adjustedCasualLeave,
      totalLeave: totalLeave,
      balanceLeave: balanceLeave
    };
    setProductData(updatedData); // Update state immediately
  };

  /** Save data to backend **/
  const handleSave = async (index) => {
    try {
      const dataToSave = productData[index];
      const staff = staffData.find(s => s.staffid === dataToSave.staffId);
      const joiningDate = new Date(staff.joining_date);

      const adjustedCasualLeave = getProratedCasualLeave(joiningDate, casualLeaveData);

      const openingBalance = Number(dataToSave.openingBalance) || 0;
      const totalLeave = openingBalance + adjustedCasualLeave;
      const balanceLeave = totalLeave;

      const payload = {
        data: [{
          staffId: dataToSave.staffId,
          opening_leave: openingBalance,
          casualLeave: adjustedCasualLeave,
          total_leave: totalLeave,
          remaining_leave: balanceLeave,
          created_user_id: 1,
          last_modified_user_id: 1,
        }]
      };

      const response = await postToAPI('opening_balance/', payload);
      if (response) {
        toast.success('Opening Balance and Leaves Saved Successfully');
        fetchOpeningBalanceData();
      }
    } catch (error) {
      toast.error('Failed to save data');
      console.error('Error saving data:', error);
    }
  };

  DataTable.Buttons.jszip(JSZip);
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  /** Initialize DataTable **/
  useEffect(() => {
    if (productData.length > 0) {
      if ($.fn.DataTable.isDataTable("#mainDatatableProductLReport")) {
        $(tableRef.current).DataTable().destroy();
      }

      const table = $(tableRef.current).DataTable({
        data: productData,
        pageLength: 25,
        columns: [
          { title: "Staff ID", data: "staffId" },
          { title: "Staff Name", data: "staffName" },
          {
            title: "Opening Balance",
            data: "openingBalance",
            render: function (data, type, row, meta) {
              return `<input type="number" class="opening-input form-control" 
                        value="${data}" 
                        data-index="${meta.row}" 
                        style="width: 80px;"/>`;
            }
          },
          { title: "Casual Leave", data: "casualLeave" },
          { title: "Available Leave", data: "balanceLeave" },
          {
            title: "Actions",
            data: null,
            render: function () {
              return `<button class="save-button btn btn-success btn-sm">Save</button>`;
            }
          }
        ],
        rowCallback: function (row, data, index) {
          const input = $('input', row);
          input.on('change', function () {
            const idx = $(this).data('index');
            const value = $(this).val();
            handleOpeningBalanceChange(idx, value);
          });

          $('.save-button', row).on('click', function () {
            handleSave(index);
          });
        }
      });

      return () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
          $(tableRef.current).DataTable().destroy();
        }
      };
    }
  }, [productData]);

  return (
    <div className="page-wrapper">
      <div className='page-content'>
        <Container>
          <Row>
            <Col>
              <Card>
                <Card.Body>
                  <Card.Title>{tableName}</Card.Title>
                  <Card className='border shadow-none mb-0'>
                    <Card.Body>
                      <Table id="mainDatatableProductLReport" ref={tableRef} className="display nowrap" width="100%">
                        <thead>
                          <tr>
                            <th>Staff ID</th>
                            <th>Staff Name</th>
                            <th>Opening Balance</th>
                            <th>Casual Leave</th>
                            <th>Available Leave</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                      </Table>
                    </Card.Body>
                  </Card>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </div>
  );
}
